// Angular
import { Injectable } from '@angular/core';
// Sore
import { Action, Selector, State, StateContext } from '@ngxs/store';
// Actions
import { ClearChatSession, SetChatSession } from './action/chatbot.action';
import { Logout } from '@cv-invision/core';
// Model
import { ChatbotStateModel } from './model/chatbot.model';

@State<ChatbotStateModel>({
	name: 'chatbot',
	defaults: new ChatbotStateModel()
})
@Injectable()
export class ChatbotState {

	/**
	 * Returns ChatbotStateModel state.
	 * @param state
	 * @constructor
	 */
	@Selector()
	static getChatbotState(state: ChatbotStateModel): ChatbotStateModel {
		return state;
	}

	/**
	 * Updates the chat session state with the provided session ID and order ID.
	 *
	 * @param {StateContext<ChatbotStateModel>} ctx - The state context for the chatbot.
	 * @param {object} payload - The payload containing session and order IDs.
	 * @param {string} payload.sessionId - The ID of the chat session to set.
	 * @param {string} payload.orderId - The ID of the associated order to set.
	 * @return {void} This method does not return any value.
	 */
	@Action(SetChatSession)
	setChatSession(ctx: StateContext<ChatbotStateModel>, {sessionId, orderId}: SetChatSession): void {
		ctx.setState({
			sessionId,
			orderId
		});
	}

	/**
	 * Clears the current chat session by resetting the session ID and order ID to null.
	 *
	 * @param {StateContext<ChatbotStateModel>} ctx - The state context instance of the chatbot containing the session data.
	 * @return {void} Does not return a value.
	 */
	@Action(ClearChatSession)
	clearChatSession(ctx: StateContext<ChatbotStateModel>): void {
		ctx.setState({
			sessionId: null,
			orderId: null
		});
	}

	/**
	 * Clear out the Chat Bot State Model
	 * @param ctx
	 */
	@Action(Logout)
	logout(ctx: StateContext<ChatbotStateModel>): void {
		ctx.setState(new ChatbotStateModel());
	}
}
